"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _featherIcons = _interopRequireDefault(require("feather-icons"));

var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function Feather(_ref) {
  var icon = _ref.icon,
      className = _ref.className,
      color = _ref.color,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      strokeWidth = _ref.strokeWidth,
      linecap = _ref.linecap,
      linejoin = _ref.linejoin,
      rest = _objectWithoutProperties(_ref, ["icon", "className", "color", "size", "width", "height", "strokeWidth", "linecap", "linejoin"]);

  if (_featherIcons.default.icons[icon]) {
    return (0, _htmlReactParser.default)(_featherIcons.default.icons[icon].toSvg(_objectSpread({}, className && {
      class: className
    }, color && {
      color: color
    }, size && {
      width: width || size,
      height: height || size
    }, strokeWidth && {
      "stroke-width": strokeWidth
    }, linecap && {
      "stroke-linecap": linecap
    }, linejoin && {
      "stroke-linejoin": linejoin
    }, rest)));
  }

  return null;
}

Feather.propTypes = {
  icon: _propTypes.default.string.isRequired,
  className: _propTypes.default.string,
  color: _propTypes.default.string,
  size: _propTypes.default.number,
  width: _propTypes.default.number,
  height: _propTypes.default.number,
  strokeWidth: _propTypes.default.number,
  linecap: _propTypes.default.string,
  linejoin: _propTypes.default.string
};
var _default = Feather;
exports.default = _default;